var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApostropheClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 705 499.1",
    style: {
      enableBackground: "new 0 0 705 499.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFC6C8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.5,446.2c10.1-6.1,20-11.8,29.6-18c33.4-21.7,62.7-47.8,86.6-79.8c11.2-14.9,19.3-31.2,23-49.5 c1.3-6.3,1.6-12.7,2.5-20.1c-5,3-8.5,6.2-12.7,7.6c-9.8,3.2-19.7,6.3-29.8,8.2c-13.2,2.4-26.5,2.9-39.9,1.1 c-18.7-2.5-35.4-9.8-51-20.1c-22.5-14.9-37.7-35-45.2-60.9c-6.4-22.1-7.5-44.8-6.1-67.6C2.1,119,9.2,92.4,24.9,68.7 C44.5,39.2,71.4,19,105.2,8.1c23.9-7.7,48.6-9.9,73.3-6.6c58.5,8,99.4,39.4,121.8,94.1c10.1,24.8,13.7,51,14.6,77.6 c1,30.4-1.2,60.4-7.8,90.1c-8.9,39.8-26.2,75.8-49.5,109c-38.7,55.4-89.3,96.7-150,125.9c-1.8,0.9-3.2,1.4-5-0.2 c-19.2-16.9-38.5-33.7-57.8-50.6C44.3,447.1,43.9,446.6,43.5,446.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M432.4,446.3c7.9-4.5,15.1-8.3,22-12.6c37.2-23.3,70.1-51.3,96.2-86.8c13.9-18.9,22.7-39.8,23.9-63.5 c0.1-1.3,0-2.6,0-4.9c-6.8,6-13.9,9.5-21.6,11.7c-51.4,14.6-98.6,6-137.2-38c-11.4-13-17.5-28.9-21.3-45.7 c-5.8-25.4-6.4-51.2-2.3-76.7c9.4-59,42.6-99.2,98.4-120.2c27-10.1,55.1-11.8,83.5-7.3c49.6,7.9,86.2,34.5,109.7,78.7 c9.9,18.7,15.1,39,18.2,59.9c3.7,24.8,3.8,49.6,2.1,74.4c-3.7,55.2-21.7,105.5-52.6,151.3c-39.2,58.1-91.2,101.4-154.2,131.7 c-2.2,1-3.6,0.8-5.3-0.7c-18.7-16.4-37.4-32.8-56.1-49.1C434.8,447.8,433.7,447.2,432.4,446.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApostropheClose);
export default __webpack_public_path__ + "static/media/apostropheClose.fa237fcdec480e7e8a435c46011401fa.svg";
export { ForwardRef as ReactComponent };